import { render, staticRenderFns } from "./drilldown-performance.vue?vue&type=template&id=ab3623b2&scoped=true"
import script from "./drilldown-performance.ts?vue&type=script&lang=ts&external"
export * from "./drilldown-performance.ts?vue&type=script&lang=ts&external"
import style0 from "./drilldown-performance.scss?vue&type=style&index=0&id=ab3623b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3623b2",
  null
  
)

export default component.exports